import { Link } from "react-router-dom";

import "./style.css"

import logo_webSpace from './../../assets/svg/svg_webSpace.svg'
import logo_mySpace from './../../assets/img/logo_mySpace_png.png'

function Header({ setShowMdlContact }) {

    return (
        <header>
            <div className="content">
                <Link to='/' className='btn_home_page'>
                    <img src={logo_webSpace} alt=" " />
                </Link>

                <nav>
                    <Link to='achievments'>Réalisations</Link>

                    <button onClick={() => setShowMdlContact(true)}>Contact</button>

                    <Link to='mySpace'>
                        <img src={logo_mySpace} alt=" " />
                    </Link>
                </nav>
            </div>
        </header>
    )
}

export default Header;